<template>
  <div class="height100 flex flex-col">
    <div class="bg-fff margin-bottom-10">
      <div class="flex flex-between flex-align-center global-padd">
        <div class="font-18 font-bold">个人会员</div>
<!--        <div>-->
<!--          <el-button type="primary" size="small" @click="tocreate">-->
<!--            <i class="el-icon-plus" style="margin-right: 5px"></i>上传文档-->
<!--          </el-button>-->
<!--        </div>-->
      </div>
      <div class="global-line"></div>
<!--      <div class="global-padd-15 margin-bottom-20">-->
<!--        <el-tabs v-model="activeName"  @tab-click="handleClick">-->
<!--          <el-tab-pane   name="first">-->
<!--          <span style="padding: 20px" slot="label">-->
<!--&lt;!&ndash;            <el-badge :value="needSH" :hidden="needSH==0" class="item" title="待审核数">&ndash;&gt;-->
<!--              全部裁判员-->
<!--&lt;!&ndash;            </el-badge>&ndash;&gt;-->
<!--            </span>-->
<!--          </el-tab-pane>-->
<!--          <el-tab-pane name="second">-->
<!--          <span slot="label">-->
<!--            <el-badge :value="needSH2" :hidden="needSH2==0" class="item" title="待审核数">-->
<!--              资质未审核-->
<!--            </el-badge>-->
<!--            </span>-->
<!--          </el-tab-pane>-->
<!--        </el-tabs>-->
<!--      </div>-->
<!--      <div class="global-line" style="margin-top: 30px"></div>-->
      <div class="global-padd-15">
        <el-form v-model="form" inline>
          <el-form-item label="会员状态：">
            <el-select size="small"
                       clearable
                       style="width: 180px"
                       v-model="form.memberStatus">
              <el-option label="生效中" :value="0" ></el-option>
              <el-option label="已过期" :value="1" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别：">
            <el-select size="small"
                       clearable
                       style="width: 180px"
                       v-model="form.sex">
              <el-option label="男" :value="0" ></el-option>
              <el-option label="女" :value="1" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电话：">
            <el-input size="small"
                      style="width: 180px"
                      clearable
                      v-model="form.phone"
                      placeholder="电话">
            </el-input>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input size="small"
                      style="width: 180px"
                      clearable
                      v-model="form.name"
                      placeholder="电话">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="searchCondition">搜索</el-button>
          </el-form-item>
          <!--                        <el-form-item>-->
          <!--                            <el-button size="small" type="primary" @click="exportT">导出</el-button>-->
          <!--                        </el-form-item>-->
        </el-form>
      </div>
    </div>
    <div class="flex1">
      <el-table height="100%" :data="tableData"
                :header-cell-style="{
                  background:'#f1f1f1'
                }"
                border>
        <el-table-column label="序号" width="100px">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="照片"  >
          <template slot-scope="scope">
            <img :src="scope.row.photo" alt="" class="memberPhoto">
          </template>
        </el-table-column>
        <el-table-column label="姓名"  prop="name">
        </el-table-column>
        <el-table-column label="性别"  >
          <template slot-scope="scope">
            <span v-if="scope.row.sex ==0">男</span>
            <span v-else-if="scope.row.sex ==1">女</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="年龄"  >
          <template slot-scope="scope">
            {{scope.row.idCard | age}}
          </template>
        </el-table-column>
        <el-table-column label="联系电话" prop="phone">
        </el-table-column>
        <el-table-column label="工作单位" prop="workUnit">
        </el-table-column>
        <el-table-column label="会员状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.memberExpireTime &&(new Date().getTime()>scope.row.memberExpireTime)" style="color: #4680FE">已过期</span>
            <span v-if="scope.row.memberExpireTime &&(new Date().getTime()<scope.row.memberExpireTime)" style="color: green">生效中</span>
            <span v-if="!scope.row.memberExpireTime" style="color: red">未入会</span>
          </template>
        </el-table-column>
        <el-table-column label="最近入会时间" >
          <template slot-scope="scope">
            {{scope.row.lastRenewalTime | dateFormat('yyyy-MM-dd hh:mm')}}
          </template>
        </el-table-column>
<!--        <el-table-column label="审核状态" >-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.checkResult==0" style="color: #4680FE">资质待审核</span>-->
<!--            <span v-if="scope.row.checkResult==1" style="color: green">资质通过</span>-->
<!--            <span v-if="scope.row.checkResult==2" style="color:red">资质不通过</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="上传时间" min-width="140">-->
<!--          <template slot-scope="scope">-->
<!--            {{scope.row.createTime | dateFormat('yyyy-MM-dd hh:mm')}}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="审核状态"  width="100">-->
<!--          <template slot-scope="scope">-->
<!--            <span class="" v-if="scope.row.checkState==0">待审核</span>-->
<!--            <span class="font-success" v-if="scope.row.checkState==1">已同意</span>-->
<!--            <span class="font-warning" v-if="scope.row.checkState==2">已驳回</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="操作"  prop="totalCostMoney">
          <template slot-scope="scope">
            <el-button type="text"  @click="agree(scope.row)"><span style="text-decoration: underline">查看</span></el-button>
            <!--                        <el-button type="text" @click="TransactionDetails(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-center global-padd bg-fff">
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="form.page"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="form.total">
      </el-pagination>
    </div>
<!--    <el-dialog-->
<!--        title="驳回理由"-->
<!--        :visible.sync="dialogVisible"-->
<!--        width="30%"-->
<!--    >-->
<!--      <div>-->
<!--            <el-input size="small"-->
<!--                      style="width:100%"-->
<!--                      rows="5"-->
<!--                      clearable-->
<!--                      type="textarea"-->
<!--                      v-model="checkRemark"-->
<!--                      placeholder="请输入驳回理由"-->
<!--            >-->
<!--            </el-input>-->
<!--          </div>-->
<!--          <span slot="footer" class="dialog-footer">-->
<!--        <el-button @click="dialogClose">取 消</el-button>-->
<!--        <el-button type="primary" @click="agreeit(2)">确 定</el-button>-->
<!--      </span>-->
<!--    </el-dialog>-->
    <el-drawer
        title="个人会员资料"
        :visible.sync="drawer"
        :direction="direction"
    >
      <div style="padding:20px;line-height: 40px">
        <div class="flex flex-between margin-bottom-20 flex-align-center">
          <div>照片</div>
          <img style="width: 60px;height: 60px" :src="agreeData.photo" alt="">
        </div>
        <div class="global-line "></div>
        <div class="flex flex-between flex-align-center ">
          <div>{{agreeData.name}}</div>
          <div>{{agreeData.idCard | age}}岁
            <i v-if="agreeData.sex==0" class="el-icon-male" style="color: #409EFF"></i>
            <i v-if="agreeData.sex==1" class="el-icon-female" style="color: palevioletred"></i>
          </div>
        </div>
<!--        <div class="global-line "></div>-->
<!--        <div class="flex flex-between flex-align-center ">-->
<!--          <div>裁判员等级</div>-->
<!--          <div>{{agreeData.refereeLevel || "未填"}}</div>-->
<!--        </div>-->
        <div class="global-line "></div>
        <div class="flex flex-between flex-align-center ">
          <div>身份证号</div>
          <div>{{agreeData.idCard}}</div>
        </div>
        <div class="global-line "></div>
        <div class="flex flex-between flex-align-center">
          <div>联系电话</div>
          <div>{{agreeData.phone}}</div>
        </div>
        <div class="global-line "></div>
        <div class="flex flex-between flex-align-center">
          <div>所在区域</div>
          <div>{{agreeData.areaName}}</div>
        </div>
        <div class="global-line"></div>
        <div class="flex flex-between flex-align-center">
          <div>工作单位</div>
          <div>{{agreeData.workUnit}}</div>
        </div>
        <div class="global-line "></div>
        <div class=" flex flex-between flex-align-center">
          <div>个人介绍</div>
          <div style="max-width: 250px;  line-height: 20px">{{agreeData.intro | nulls}}</div>
        </div>
        <div class="global-line"></div>
<!--        <div class="flex flex-between flex-align-center">-->
<!--          <div>擅长项目</div>-->
<!--          <div>{{agreeData.skillSport}}</div>-->
<!--        </div>-->

<!--        <div class="global-line"></div>-->
        <div class="margin-bottom-10">
          <div class="margin-bottom-20">资质证书</div>
          <div class="flex text-center" style="line-height: 20px">
<!--            <div class=" margin-rt-15">-->
<!--              <el-image-->
<!--                  style="width: 100px; height: 100px"-->
<!--                  :src="agreeData.refereeCertObjectkey"-->
<!--                  :preview-src-list="[agreeData.refereeCertObjectkey]">-->
<!--              </el-image>-->
<!--              <div>裁判员证书</div>-->
<!--            </div>-->
            <div class=" margin-rt-15">
              <el-image
                  style="width: 100px; height: 100px"
                  :src="agreeData.idCardFrontObjectkey"
                  :preview-src-list="[agreeData.idCardFrontObjectkey]">
              </el-image>
              <div>身份证正面</div>
            </div>
            <div>
              <el-image
                  style="width: 100px; height: 100px"
                  :src="agreeData.idCardBackObjectkey"
                  :preview-src-list="[agreeData.idCardBackObjectkey]">
              </el-image>
              <div>身份证反面</div>
            </div>
          </div>
        </div>
        <div class="global-line"></div>
        <div>
          <div><span class="margin-rt-10">参赛经历</span><i @click="dialogVisible2=true" class="el-icon-circle-plus-outline" style="cursor: pointer;color: #409EFF"></i></div>
          <el-timeline style="line-height: 18px">
            <el-timeline-item
                v-for="(activity, index) in exp"
                :key="index"
                :timestamp="dateFormatCustom(activity.experienceBeginTime, 'yyyy年MM月dd日')">
              {{activity.experienceTitle}}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-drawer>
    <el-dialog
        title="参赛经验"
        :visible.sync="dialogVisible2"
        width="450px"
    >
      <div>
        <el-form v-model="form3">
          <el-form-item label="参赛时间：">
            <el-date-picker
                style="width: 180px"
                v-model="form3.experienceBeginTime"
                type="date"
                size="small"
                value-format="timestamp"
                placeholder="参赛时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="参赛内容：">
            <el-input size="small"
                      style="width:300px"
                      rows="5"
                      clearable
                      type="textarea"
                      v-model="form3.experienceTitle"
                      placeholder="参赛内容"
            >
            </el-input>
          </el-form-item>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2=false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'person',
  data(){

    return {
      // activeName:'first',
      // needSH:10,
      // needSH2:10,
      exp:[],
      dialogVisible2:false,
      // checkRemark:'',
      agreeData:{},
      refereeInfo:{},
      drawer: false,
      direction: 'rtl',
      // areaCode:'',
      // activeName:'',
      form3:{
        objectType:'user',
        experienceBeginTime:'',
        experienceTitle:''
      },
      form:{
        // checkState:undefined,
        // category:undefined,
        page:1 ,
        total:0
      },
      // options1:[],
      // options2:[],

      // tagList:[],
      tableData:[],
    }
  },
  mounted () {
    this.getList()

  },
  watch:{
    // dialogVisible(){
    //   if(this.dialogVisible==false){
    //     this.checkRemark=undefined
    //   }
    // }
  },
  methods:{
    submit(){
      this.form3.objectId=this.agreeData.userId
      this.$http.get('/rest/experience/modify', this.form3,res => {
        this.$message.success('提交完成！')
        this.getEXP(this.agreeData.userId)
        this.dialogVisible2=false
      })
    },
    getEXP(id){
      this.$http.post('/rest/experience/list', {objectId:id}, res => {
        this.exp=res
      })
    },
    // dialogClose(){
    //   this.dialogVisible=false
    // },
    //
    // agreeit(type){
    //   this.$confirm('确认'+(type==1?'同意':'驳回')+'吗？')
    //   .then(() => {
    //     this.$http.get('/rest/referee/check', {userId:this.agreeData.userId,checkResult:type,checkRemark:this.checkRemark},res => {
    //       this.$message.success('审核完成！')
    //     })
    //     this.drawer=false
    //     this.dialogVisible=false
    //     setTimeout(this.getList,1000)
    //   })
    //   .catch(() => {});
    //
    // },
    agree(data){
      this.drawer=true
      // this.$http.get("/rest/referee/detail", {userId:data.userId},res => {
        this.agreeData=data
      this.getEXP(data.userId)
      //   this.refereeInfo=res.userInfo
      // })
    },
    // loadNodeOrg (node, resolve) {
    //   // console.log(464564)
    //   // console.log(node)
    //   let url = '/rest/public/nation/area/list'
    //   this.$http.get(url, {areaCode:node.level === 0?'':node.data.areaCode},res => {
    //     let datas = []
    //     // console.log(res)
    //     res.forEach(item => {
    //       let data = {
    //         value: item.areaCode,
    //         label: item.areaName,
    //         areaCode: item.areaCode
    //       }
    //       // if (item.parentAreaCode < 4) {
    //         data.leaf = false
    //       // } else {
    //       //   data.leaf = true
    //       // }
    //       datas.push(data)
    //     })
    //     resolve(datas)
    //   })
    // },
    // getOrgVal(val){
    //   // console.log(val,this.$refs['cascader'].getCheckedNodes()[0].label)
    //   // this.orgName=this.$refs['cascader'].getCheckedNodes()[0].label
    //   this.$refs['cascader'].dropDownVisible = false;
    // },
    // handleClick(){},

    searchCondition(){
      this.form.page=1
      this.getList()
    },
    handleCurrentChange(a){
      this.form.page=a
      this.getList()
    },

    getList(){
      this.$http.post('/rest/member/list', this.form, res => {
        this.tableData=res.data
        this.form.total=res.total
      })
    },
    // toDetail(id){
    //  // this.openNewPage('/teammanagement/detail/'+id)
    //  this.$router.push('/teammanagement/detail/'+id)
    // }
  }
}
</script>

<style scoped>
/*/deep/ .el-tabs__nav-scroll,/deep/ .el-tabs__nav-wrap{*/
/*  overflow: visible;*/
/*}*/
/*/deep/ .el-tabs__nav-wrap::after{*/
/*  background-color: transparent;*/
/*}*/
/*/deep/ .el-badge__content.is-fixed{*/
/*  top:6px*/
/*}*/
.memberPhoto{
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
</style>



// WEBPACK FOOTER //
// src/view/vipManagement/person/list.vue